import React from 'react';
import '../styles/PageBanner.css';

const PageBanner = ({ title, description }) => {
  return (
    <div className="page-banner">
      <div className="banner-content">
        <h1>{title}</h1>
        {description && <p>{description}</p>}
      </div>
    </div>
  );
};

export default PageBanner;
